
import "./floating.css";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

function FloatingContact() {
  return (
    <div className="floating-container">

      {/* CALL BUTTON */}
      <a href="tel:08884448033" className="float-btn call" title="Call Us">
        <FaPhoneAlt />
      </a>

      {/* WHATSAPP BUTTON */}
      <a
        href="https://wa.me/9188844448033"
        target="_blank"
        rel="noopener noreferrer"
        className="float-btn whatsapp"
        title="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>

    </div>
  );
}

export default FloatingContact;